function hintActionType(actionType) {
	return `${PREFIX}.${actionType}`;
}

export const PREFIX = 'hints';

export const HINTS_SHOW_HINT = hintActionType('SHOW_HINT');
export const HINTS_HIDE_HINT = hintActionType('HIDE_HINT');
export const HINTS_SET_USE_HINTS = hintActionType('SET_USE_HINTS');
